import { Injectable, EventEmitter } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { State } from 'src/app/form/state.model';
import { RequestModel } from 'src/app/shopping-cart/request-model.model';

@Injectable({
  providedIn: 'root'
})
export class EventService {
  confirmEvent = new EventEmitter<State>();

  private requestSubject = new BehaviorSubject<number>(null);
  private requestModelSubject = new BehaviorSubject<RequestModel>(null);

  constructor() { }

  get request(): number {
    return this.requestSubject.value;
  }

  set request(index: number) {
    this.requestSubject.next(index);
  }

  get requestModel(): RequestModel {
    return this.requestModelSubject.value;
  }

  set requestModel(requestModel: RequestModel) {
    this.requestModelSubject.next(requestModel);
  }
}
